import styled from "styled-components";
import { Dialog } from "@mui/material";

export const ModalBox = styled(Dialog)`
font: normal normal normal 16px/20px Open Sans;
letter-spacing: 0px;
color: ${({ theme }) => {
  return theme.colors.title;
}};
opacity: 1;
  & .MuiDialog-paper {
    ${({ isSiteRefModal }) => isSiteRefModal && "margin: 0;"}
    ${({ isSiteRefModal }) => isSiteRefModal && "padding: 0;"}
    position: absolute;
    top: 50%;
    left: 50%;
    width : ${({ small, midSize, vw }) => {
      if (vw) return `${vw};`;
      if (small) return "30vw;";
      if (midSize) return "58vw;";
      return null;
    }};
    transform: translate(-50%, -50%);
    min-width: ${({ small, midSize }) => {
      if (small) return "30vw;";
      if (midSize) return "58vw;";
      return "70vw;";
    }};
    min-height: ${({ small, version, midSize }) => {
      if (small) return "30vh;";
      if (version) return "0px;";
      if (midSize) return "30vh;"
      return "60vh;";
    }};
    text-align: left;

    height: fit-content;
    max-height: 85vh;
    background-color: ${({ theme }) => {
      return theme.colors.background;
    }};
    border-radius: 5px;
  }
  & .MuiDialogContent-root {
    ${({ isSiteRefModal }) => isSiteRefModal && "margin: 0;"}
    ${({ isSiteRefModal }) => isSiteRefModal && "padding: 0;"}
  }
  & .MuiDialogActions-root {
    padding: 20px;
  }
`;

export const TitleModal = styled.div`
  text-align: left;
  margin-left: 30px;
  font: normal normal 600 18px/22px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.darkgrey;
  }};
  opacity: 1;
`;
